import React from "react";
import { Link } from "react-router-dom";
const questions = [
  {
    question: `What if I don't have a PayPal, Venmo, or Zelle account, how will I get paid?`,
    answer: `As an alternative to those methods, we offer our own exclusive QR-coded virtual gift card (eksplode! CodeCard), which we send to your smartphone and can be use at any one of our participating Retailer outlets or online stores. (A list of participating Retailers is maintained on our Stars' Workshop page).`,
  },
  {
    question: ` What if I share my EAC with others but no one buys the product, or any other?`,
    answer: `The money rewarded to EAC Members comes from the sale that they made happen by sharing their EAC with others. If there is no sale, then there is no money generated within the system to pay you.`,
  },
  {
    question: `What if the product featured in my EAC is not purchased by the person I sent it to, but a different product is purchase by that person, will I still get paid?`,
    answer: `Yes. We require our Retailers to offer a reward amount for each and every item listed on their eksplode! catalog. Our system tracks all sales through each Members' eksplode! Code (which is linked to every EAC shared), thus, all purchases made through your EAC will be credited to you, and, you will receive the reward amount offered by the Retailer for the item purchased. In short, as long as the recipient of your EAC makes a purchase through your EAC, you get paid.`,
  },
  {
    question: ` Do I loose my reward payment if a product I promoted is returned to the Retailer for a refund?`,
    answer: ` No. Our automated system will route your reward payment directly into your PayPal, Venmo, zelle, or eksplode! CodeCard account. Whether the customer decides to return the product has nothing to do with you. You made the sale happen, you keep the money.`,
  },
];

const FAQs = () => {
  return (
    <div>
      <section>
        <div>
          <h3>FAQs</h3>
          <br />
          <h4 className="mb-2">
            Frequently Asked Questions eksplode!'s Video Ad Contest (VAC)
            Program
          </h4>
          <div className="row mb-3">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header" id="headingOne">
                  <h6 className="mb-0">
                    1. Do I need to be a certain age to participate in eksplode!'s
                    EAC program?
                  </h6>
                </div>

                <div>
                  <div className="card-body">
                    <p>
                      We welcome participants 13 and older. However, if you are
                      between 13 and 17, you must have a parent or legal
                      guardian fill out and return our Parental Consent Form
                      authorizing you to participate in our program. To access
                      our form{" "}
                      <Link to={`${process.env.PUBLIC_URL}/fill/consent-form`}>
                        Click Here
                      </Link>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {questions.map((q, i) => (
            <div className="row mb-3" key={q.question.slice(2, 10)}>
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header" id="headingOne">
                    <h6 className="mb-0">
                      {i + 2}. {q.question}
                    </h6>
                  </div>

                  <div>
                    <div className="card-body">
                      <h7>{q.answer}</h7>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default FAQs;
